// Plan utils

export const PLAN_GRID_VIEWS = {
	default: 1,
	grid: 2,
	ubications: 3,
	hours: 4,
	combo: 5,
	vertical: 6,
	ubication_grouped: 7,
	shifts: 8,
};

/** Filas = 1 por empleado (Funciones / Simple / Ubicaciones / Horas). */
export const isEmployeeRowPlanView = (view) =>
	view === PLAN_GRID_VIEWS.default ||
	view === PLAN_GRID_VIEWS.grid ||
	view === PLAN_GRID_VIEWS.ubications ||
	view === PLAN_GRID_VIEWS.hours;

/** Turnos / Ubicaciones agrupadas: reagrupan assignments. */
export const isGroupedPlanView = (view) =>
	view === PLAN_GRID_VIEWS.shifts ||
	view === PLAN_GRID_VIEWS.ubication_grouped;

/**
 * Vistas con paginación encubierta al abrir el plan.
 * Fase A+B+C: employee-row (incl. Horas) + Turnos / Ubic. agrupadas.
 */
export const supportsPlanAssignmentsPagination = (view) =>
	view === PLAN_GRID_VIEWS.default ||
	view === PLAN_GRID_VIEWS.grid ||
	view === PLAN_GRID_VIEWS.ubications ||
	view === PLAN_GRID_VIEWS.hours ||
	view === PLAN_GRID_VIEWS.shifts ||
	view === PLAN_GRID_VIEWS.ubication_grouped;

/** Skeletons de filas durante carga paginada (mismas vistas que la allowlist). */
export const supportsPlanLoadSkeletons = (view) =>
	supportsPlanAssignmentsPagination(view);

/** Bloque de necesidades debajo del plan (no Horas ni agrupadas). */
export const showsStaffingUnderPlan = (view) =>
	view === PLAN_GRID_VIEWS.default ||
	view === PLAN_GRID_VIEWS.grid ||
	view === PLAN_GRID_VIEWS.ubications;